const USERSTATUS = {
    NOT_LOADED: 0,
    NONE: 1,
    LOADED: 2
}

export default USERSTATUS
